export enum SiteTab {
  ACTIVE = 'sites',
  INACTIVE = 'inactive-sites',
  SITES_WITHOUT_MAPPING = 'sites-without-mapping',
}
